module.exports = __webpack_public_path__ + "static/media/ads_4x3_12.95283734.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ads_4x3_12.svg
// module id = 262
// module chunks = 0